export default __webpack_public_path__ + "static/assets/med_spheric_solid_03_mask.370418d9.png";